import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "custom-title flex items-center md:h-[40px]" }
const _hoisted_2 = { class: "h-[calc(100vh-122px)] md:h-[calc(100vh-112px)] overflow-y-auto" }
const _hoisted_3 = {
  class: "m-4 p-4",
  style: {"border":"2px solid #d1d5db","border-radius":"10px"}
}
const _hoisted_4 = { class: "md:flex md:justify-center" }
const _hoisted_5 = { class: "hidden md:block md:w-[500px]" }
const _hoisted_6 = { class: "w-full md:hidden" }
const _hoisted_7 = { class: "mb-6 flex justify-center" }
const _hoisted_8 = {
  key: 0,
  class: "text-red-500 text-xs"
}
const _hoisted_9 = { class: "flex justify-center" }
const _hoisted_10 = {
  class: "m-4",
  style: {"border":"2px solid #d1d5db","border-radius":"10px"}
}
const _hoisted_11 = { class: "md:hidden" }
const _hoisted_12 = ["onClick"]
const _hoisted_13 = { class: "hidden md:block w-full" }
const _hoisted_14 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_header = _resolveComponent("el-header")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_mian = _resolveComponent("el-mian")!
  const _component_el_container = _resolveComponent("el-container")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_component_el_container, { style: {"height":"calc(100vh - 52px)"} }, {
    default: _withCtx(() => [
      _createVNode(_component_el_header, { style: {"height":"0px"} }),
      _createVNode(_component_el_mian, { style: {"padding-bottom":"20px"} }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("span", null, "個人設定 (" + _toDisplayString(_ctx.getUserName()) + ")", 1)
          ]),
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _cache[8] || (_cache[8] = _createElementVNode("p", { class: "text-lg text-bold mb-4" }, "パスワード変更", -1)),
              _createElementVNode("div", _hoisted_4, [
                _createVNode(_component_el_form, {
                  model: _ctx.passwordForm,
                  rules: _ctx.rules,
                  ref: "formRef",
                  "label-width": "auto"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_5, [
                      _createVNode(_component_el_form_item, {
                        label: "現在のパスワード:",
                        prop: "current_password"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            "show-password": "",
                            modelValue: _ctx.passwordForm.current_password,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.passwordForm.current_password) = $event)),
                            placeholder: "現在のパスワード",
                            autocomplete: "off"
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, {
                        label: "新しいパスワード:",
                        prop: "password"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            "show-password": "",
                            modelValue: _ctx.passwordForm.password,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.passwordForm.password) = $event)),
                            placeholder: "新しいパスワード",
                            autocomplete: "off"
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, {
                        label: "新しいパスワード（確認）:",
                        prop: "password_confirmation"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            "show-password": "",
                            modelValue: _ctx.passwordForm.password_confirmation,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.passwordForm.password_confirmation) = $event)),
                            placeholder: "新しいパスワード（確認）",
                            autocomplete: "off"
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("div", _hoisted_6, [
                      _createVNode(_component_el_form_item, { prop: "current_password" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            "show-password": "",
                            modelValue: _ctx.passwordForm.current_password,
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.passwordForm.current_password) = $event)),
                            placeholder: "現在のパスワード",
                            autocomplete: "off"
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, { prop: "password" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            "show-password": "",
                            modelValue: _ctx.passwordForm.password,
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.passwordForm.password) = $event)),
                            placeholder: "新しいパスワード",
                            autocomplete: "off"
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, { prop: "password_confirmation" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            "show-password": "",
                            modelValue: _ctx.passwordForm.password_confirmation,
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.passwordForm.password_confirmation) = $event)),
                            placeholder: "新しいパスワード（確認）",
                            autocomplete: "off"
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("div", _hoisted_7, [
                      (_ctx.errorMessage)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_8, _toDisplayString(_ctx.errorMessage), 1))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_9, [
                      _createVNode(_component_el_button, {
                        type: "info",
                        class: "w-full md:w-80",
                        onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.handleChangePassword(_ctx.formRef)))
                      }, {
                        default: _withCtx(() => _cache[7] || (_cache[7] = [
                          _createTextVNode("パスワード変更")
                        ])),
                        _: 1
                      })
                    ])
                  ]),
                  _: 1
                }, 8, ["model", "rules"])
              ])
            ]),
            _createElementVNode("div", _hoisted_10, [
              _cache[9] || (_cache[9] = _createElementVNode("p", { class: "text-lg text-bold m-4" }, "ログイン端末", -1)),
              _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_11, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.mTableData, (item) => {
                  return (_openBlock(), _createBlock(_component_el_card, {
                    style: {"border-top":"1px solid #d1d5db","border-bottom":"1px solid #d1d5db","border-radius":"0px"},
                    key: item.user_id
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_row, { align: "middle" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_col, { span: 21 }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", null, _toDisplayString(item.user_id), 1),
                              _createElementVNode("div", null, _toDisplayString(item.device + "," + item.browser + "," + item.os), 1),
                              _createElementVNode("div", null, _toDisplayString(item.language + "," + item.timezone), 1),
                              _createElementVNode("div", null, _toDisplayString(item.updated_date), 1)
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_component_el_col, {
                            span: 2,
                            class: "ml-2",
                            align: "right"
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("span", {
                                class: "material-symbols-outlined cursor-pointer",
                                onClick: ($event: any) => (_ctx.handleDeleteFCMToken(item))
                              }, " delete ", 8, _hoisted_12)
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1024))
                }), 128))
              ])), [
                [_directive_loading, _ctx.loading]
              ]),
              _createElementVNode("div", _hoisted_13, [
                _withDirectives((_openBlock(), _createBlock(_component_el_table, { data: _ctx.mTableData }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_table_column, {
                      prop: "updated_date",
                      label: "更新日"
                    }),
                    _createVNode(_component_el_table_column, {
                      prop: "user_id",
                      label: "ID"
                    }),
                    _createVNode(_component_el_table_column, {
                      prop: "device",
                      label: "デバイス"
                    }),
                    _createVNode(_component_el_table_column, {
                      prop: "browser",
                      label: "ブラウザ"
                    }),
                    _createVNode(_component_el_table_column, {
                      prop: "os",
                      label: "OS"
                    }),
                    _createVNode(_component_el_table_column, {
                      prop: "language",
                      label: "言語"
                    }),
                    _createVNode(_component_el_table_column, {
                      prop: "timezone",
                      label: "タイムゾーン"
                    }),
                    _createVNode(_component_el_table_column, {
                      label: "削除",
                      width: "52",
                      align: "center"
                    }, {
                      default: _withCtx((scope) => [
                        _createElementVNode("span", {
                          class: "material-symbols-outlined cursor-pointer mt-2",
                          onClick: ($event: any) => (_ctx.handleDeleteFCMToken(scope.row))
                        }, " delete ", 8, _hoisted_14)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["data"])), [
                  [_directive_loading, _ctx.loading]
                ])
              ])
            ])
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}